import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { env } from '@/lib/env';
import type { CardReader } from '@/types/sale';
import type { UserDeviceBinding } from '@/types/device';

interface DeviceState {
  name: string | null;
  ticketPrinterId: string | null;
  cashlessReaderId: string | null;
  reader: CardReader;
  hydrateFromBinding: (binding: UserDeviceBinding | null) => void;
  clear: () => void;
  isBound: () => boolean;
}

const DEFAULT_READER: CardReader = {
  mid: env.CASHLESS_READER_MID,
  tid: env.CASHLESS_READER_TID,
};

export const useDeviceStore = create<DeviceState>()(
  persist(
    (set, get) => ({
      name: null,
      ticketPrinterId: null,
      cashlessReaderId: null,
      reader: DEFAULT_READER,

      hydrateFromBinding: (binding) => {
        if (!binding) {
          set({ name: null, ticketPrinterId: null, cashlessReaderId: null });
          return;
        }
        set({
          name: binding.name ?? null,
          ticketPrinterId: binding.ticketPrinterId ?? null,
          cashlessReaderId: binding.cashlessReaderId ?? null,
          reader: binding.reader ?? get().reader ?? DEFAULT_READER,
        });
      },

      clear: () =>
        set({
          name: null,
          ticketPrinterId: null,
          cashlessReaderId: null,
          reader: DEFAULT_READER,
        }),

      isBound: () => Boolean(get().ticketPrinterId),
    }),
    { name: 'ticketbox_device' },
  ),
);
